module.exports = __webpack_public_path__ + "src/images/measurements/elbowCircumference.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/elbowCircumference.jpg
// module id = 1145
// module chunks = 0